export default __webpack_public_path__ + "static/media/G0005.e6abb562.png";